/**
 * Creates an array of evenly distributed position values between 0 and 1.
 *
 * This function generates position values that are useful for animations,
 * gradients, or any scenario requiring evenly spaced points in a normalized range.
 *
 * @param {number} length - The number of position values to generate.
 * @returns {number[]} An array of evenly distributed values between 0 and 1.
 *
 * @example
 * // Returns [0, 0.33, 0.67, 1]
 * createDefaultPositions(4);
 *
 * @example
 * // Returns [0, 0.5, 1]
 * createDefaultPositions(3);
 *
 * @example
 * // Returns [0, 1]
 * createDefaultPositions(2);
 */
export function createDefaultPositions(length: number): number[] {
    return Array.from({ length }, (_, i) => Math.round((i / (length - 1)) * 100) / 100);
}
